import { Core } from "@faire/design-tokens";
import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var SearchResultNotFound = function SearchResultNotFound(_ref) {
  var width = _ref.width,
    searchWord = _ref.searchWord,
    clearSearch = _ref.clearSearch;
  return /*#__PURE__*/React.createElement(SearchResultNotFoundWrapper, {
    width: width
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "w+So6S",
    defaultMessage: [{
      "type": 0,
      "value": "A sua pesquisa por \""
    }, {
      "type": 1,
      "value": "searchWordCompanyName"
    }, {
      "type": 0,
      "value": "\" não corresponde a nenhuma encomenda recente."
    }],
    values: {
      searchWordCompanyName: searchWord
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    onClick: clearSearch
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4YJHut",
    defaultMessage: [{
      "type": 0,
      "value": "Limpar pesquisa"
    }]
  })));
};
var SearchResultNotFoundWrapper = styled(Column).attrs({
  align: {
    desktopAndAbove: "center",
    mobileAndAbove: "flex-start"
  },
  justify: "center"
}).withConfig({
  displayName: "SearchResultNotFound__SearchResultNotFoundWrapper"
})(["padding:", ";width:", ";height:130px;background-color:", ";"], getSpacing("2x"), function (props) {
  var _props$width;
  return (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : "100%";
}, Core.surface.subdued);